export default __webpack_public_path__ + "static/media/question_green.89c0b1cc.svg";